<template>
  <div>
    <v-form>
      <v-row>
        <v-col cols="12" sm="4">
          <!-- Badge removes the effect of width 100% on text field, hence set specifically -->
          <v-badge overlap bordered color="secondary" style="width: 100%">
            <template v-slot:badge>{{ indexSize }}</template>
            <v-text-field
              v-model="searchQuery"
              solo
              clearable
              label="Search Text"
              messages="Start typing"
              prepend-inner-icon="mdi-magnify"
              @input="onInputDebounced"
            ></v-text-field>
          </v-badge>
        </v-col>
        <v-col cols="12" sm="8">
          <!-- TODO try with autocomplete with chips instead -->
          <!-- Autocomplete allows both typing and drop down, vs select whe reonly drop down is supported -->
          <!-- display: block -->
          <v-autocomplete
            chips
            clearable
            deletable-chips
            multiple
            solo
            auto-select-first
            hide-selected
            messages="Start typing or click drop down"
            menu-props="closeOnContentClick"
            prepend-inner-icon="mdi-filter-variant"
            label="Select Types"
            v-model="typeFilter"
            :items="typesMap"
            item-text="name"
            item-value="value"
          ></v-autocomplete>
        </v-col>
      </v-row>
    </v-form>

    <v-row no-gutters>
      <individual-list :ids="ids" :highlights="queryStrings"></individual-list>
    </v-row>
  </div>
</template>

<script>
import IndividualList from '@/components/IndividualList.vue'

import debounce from 'debounce'

export default {
  components: { IndividualList },
  data: () => ({
    searchQuery: '',
    typeFilter: [],
    typesMap: [],
    // TODO the selection doesnt seem to be used. Refactor.
    selection: { ids: [] },
  }),
  mounted() {
    // this.selection = this.$wob.indexSelector.createSelection()
    // console.log('components.individual-search.mounted', this.$wob.index.ids)
    this.searchQuery = this.$store.getters.getQuery
    this.typeFilter = this.$store.getters.getTypeQuery
    this.$wob.types.query(this.typeFilter)

    // Calculate types map and set filter according to query filter.
    // TODO refactor, place in method, also used in watchers.
    this.typesMap = this.types
      .map((t) => {
        return { name: t.split('#').pop().split('/').pop(), value: t }
      })
      .sort(({ name: n1 }, { name: n2 }) => n1.localeCompare(n2))
    // Remove values from the filter if disappeared from types map,
    // eg when last individual of a given type is deleted.
    this.typeFilter = this.typeFilter.filter((t) =>
      this.typesMap.map((e) => e.value).includes(t)
    )
    this.$store.commit('setTypeQuery', this.typeFilter)

    console.log('views.search-view.mounted', this.searchQuery, this.typeQuery)

    // TODO refactor, remove below, but the query on the index must be run here instead...
    this.updateSelection()
  },

  computed: {
    indexSize: function () {
      return this.ids.length
    },
    queryStrings: function () {
      return this.searchQuery?.split(' ').filter((s) => !!s) || []
    },
    ids: function () {
      const indexIds = this.$wob.index.ids
      const typesIds = this.$wob.types.ids
      return indexIds.filter((i) => typesIds.includes(i))
    },
    types: function () {
      return this.$wob.types.list
    },
    exceptions: function () {
      return this.$wob.exceptions.ids
    },
  },
  watch: {
    typeFilter: function (newFilter) {
      this.$store.commit('setTypeQuery', newFilter)
      this.$wob.types.query(newFilter)
    },
    types: async function (newTypes) {
      this.typesMap = newTypes
        .map((t) => {
          return { name: t.split('#').pop().split('/').pop(), value: t }
        })
        .sort(({ name: n1 }, { name: n2 }) => n1.localeCompare(n2))

      // Remove values from the filter if disappeared from value map.
      this.typeFilter = this.typeFilter.filter((t) =>
        this.typesMap.map((e) => e.value).includes(t)
      )
      this.$store.commit('setTypeQuery', this.typeFilter)
    },
  },
  methods: {
    onInputDebounced: debounce(function () {
      console.log(
        'components.individual-search.methods.on-input-debounced',
        this.searchQuery
      )
      this.updateSelection()
      this.$store.commit('setQuery', this.searchQuery)
    }, 200),

    // TODO deprecated input event handler...
    onInput: function () {
      console.log(
        'components.individual-search.methods.on-input',
        this.searchQuery
      )
      this.updateSelection()
      this.$store.commit('setQuery', this.searchQuery)
    },

    updateSelection: function () {
      console.log(
        'components.individual-search.methods.update-selection',
        this.searchQuery,
        this.typeQuery
      )
      this.selection = this.$wob.index.query(this.searchQuery)
    },
  },
}
</script>
